export type Importance = 'critical' | 'high' | 'medium' | 'low' | 'unknown'

export const DEVICE_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: 'workstation', label: 'Workstation' },
  { value: 'server', label: 'Server' },
  { value: 'domain_controller', label: 'Domain Controller' },
  { value: 'file_server', label: 'File Server' },
  { value: 'mail_server', label: 'Mail Server' },
  { value: 'web_server', label: 'Web Server' },
  { value: 'database_server', label: 'Database Server' },
  { value: 'network_device', label: 'Network Device' },
  { value: 'mobile_device', label: 'Mobile Device' },
]

export const IMPORTANCE_OPTIONS: { value: Importance; label: string }[] = [
  { value: 'unknown', label: 'Unknown' },
  { value: 'critical', label: 'Critical' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
]

export const INPUT_CLASS =
  'w-full rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 text-sm text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500'
export const SELECT_CLASS =
  'w-full rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 text-sm text-slate-900 dark:text-slate-100'
export const LABEL_CLASS = 'block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1'
export const HELP_CLASS = 'mt-1 text-xs text-slate-500 dark:text-slate-400'
